import { Component, computed, inject, input, output } from '@angular/core'
import { HttpService } from '../../services/http.service'
import { environment } from '../../environment/environment'

@Component({
  selector: 'help-popover',
  styles: [
    `
      .help-popover {
        position: fixed;
        z-index: 9000;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        min-width: 280px;
        padding: 16px;
      }

      .help-version {
        font-size: 13px;
        color: #6b7280;
        margin-bottom: 12px;
      }

      .help-contact {
        font-size: 13px;
        color: #374151;
        margin-bottom: 12px;
        line-height: 1.5;
      }

      .help-contact a {
        color: #005f7f;
        text-decoration: none;
      }

      .help-contact a:hover {
        text-decoration: underline;
      }

      .help-download {
        display: block;
        color: #005f7f;
        font-size: 13px;
        text-decoration: none;
        cursor: pointer;
      }

      .help-download:hover {
        text-decoration: underline;
      }
    `,
  ],
  template: `
    @if (visible() && position()) {
      <div
        class="help-popover"
        [style.left.px]="popoverPosition().x"
        [style.top.px]="popoverPosition().y"
        (mouseenter)="mouseEnter.emit()"
        (mouseleave)="mouseLeave.emit()"
      >
        <div class="help-version">Version {{ version }}</div>
        <div class="help-contact">
          For further assistance, please contact
          <a [href]="'mailto:' + helpEmail">{{ helpEmail }}</a
          >.
        </div>
        <a class="help-download" (click)="downloadUserGuide($event)">
          Traction Travel User Guide
        </a>
      </div>
    }
  `,
})
export class HelpPopoverComponent {
  private httpService = inject(HttpService)

  visible = input.required<boolean>()
  position = input.required<{ x: number; y: number } | null>()
  mouseEnter = output<void>()
  mouseLeave = output<void>()

  version = environment.version
  helpEmail = environment.helpEmail

  popoverPosition = computed(() => {
    if (!this.position()) return { x: 0, y: 0 }

    const popoverWidth = 280
    const popoverHeight = 120
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    let x = this.position()!.x
    let y = this.position()!.y + 10

    // Adjust horizontal position if popover would overflow viewport
    if (x + popoverWidth > viewportWidth) {
      x = viewportWidth - popoverWidth - 10
    }

    // Adjust vertical position if popover would overflow viewport
    if (y + popoverHeight > viewportHeight) {
      y = this.position()!.y - popoverHeight - 10
    }

    return { x, y }
  })

  downloadUserGuide(event: Event) {
    event.preventDefault()
    this.httpService.downloadFile('/help/usermanual')
  }
}
